import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import Credentials from '@/models/Credentials';

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // eslint-disable-next-line max-len
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});
export default new Vuex.Store({
  state: {
    logged: false,
    credentials: new Credentials('null', 'null'),
  },
  mutations: {
    login(state, credentials: Credentials) {
      // @ts-ignore
      state.credentials = credentials;
      // @ts-ignore
      state.logged = true;
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocalStorage.plugin],
});
